import axios from 'axios';

export async function getSectors() {
  return axios.get(`${process.env.VUE_APP_DIGISCORE_API}/sectors`);
}

export default {};
